<ng-container *ngIf="relatedCourses.length > 0">
  <a name="related-courses"></a>
  <h6>Related Courses</h6>
  <ul>
    <li *ngFor="let relatedCourse of relatedCourses">
      <a [routerLink]="['../', relatedCourse.alias]">{{relatedCourse.title}}</a>
    </li>
  </ul>
</ng-container>